import { useState } from "react";
import { Link } from "react-router-dom";

import logo from "../../assets/logo.svg";
import AnimatedLink from "../../hooks/AnimatedLink";

import { useSpline } from "../../context/SplineContext";

export default function MainNavigation({ className }) {
  const [isActive, setIsActive] = useState(false);

  const { splineObjectRef, isSplineReady } = useSpline();

  const handleActive = () => {
    setIsActive((prevState) => !prevState);

    if (isSplineReady) {
      if (!isActive) {
        document.querySelector("body").classList.add("menu-disabled");
        document.querySelector("body").classList.add("active");
        document.querySelector(".spline-parent").classList.add("spline-active");

        document.querySelector(".hero-section-all").classList.add("active");

        setTimeout(function () {
          document.querySelector("body").classList.remove("menu-disabled");
        }, 1000);
      } else {
        document.querySelector("body").classList.add("menu-disabled");
        document.querySelector("body").classList.remove("active");

        setTimeout(function () {
          document.querySelector("body").classList.remove("menu-disabled");
        }, 1200);

        setTimeout(function () {
          document
            .querySelector(".hero-section-all")
            .classList.remove("active");
        }, 1400);

        setTimeout(function () {
          document
            .querySelector(".spline-parent")
            .classList.remove("spline-active");
        }, 1500);
      }
    }
  };

  const handleLink = () => {
    setIsActive((prevState) => !prevState);

    setTimeout(function () {
      document.querySelector(".hero-section-all").classList.add("active");
    }, 500);

    setTimeout(function () {
      document.querySelector(".hero-section-all").classList.remove("active");
    }, 1500);

    setTimeout(function () {
      document
        .querySelector(".spline-parent")
        .classList.remove("spline-active");

      document.querySelector("body").classList.remove("active");
    }, 1600);
  };

  return (
    <header>
      <div className="container">
        <div className={`main-nav ${className}`}>
          <div className="main-nav__logo">
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className="main-nav__menu">
            <div
              className={`main-nav__menu--hamburger ${
                isActive ? "active" : ""
              }`}
              onClick={handleActive}
            >
              <span className="line-1"></span>
              <span className="line-2"></span>
              <span className="line-3"></span>
            </div>
            <div
              className={`main-nav__menu--overlay ${isActive ? "active" : ""}`}
            ></div>
            <div
              className={`main-nav__menu--items ${isActive ? "active" : ""}`}
            >
              <div className="main-nav__menu--items--links">
                <div className="link-wrapper">
                  <AnimatedLink text="Home" href="/" handleMenu={handleLink} />
                </div>
                <div className="link-wrapper">
                  <AnimatedLink
                    text="About"
                    href="/about"
                    handleMenu={handleLink}
                  />
                </div>
                <div className="link-wrapper">
                  <AnimatedLink
                    text="Process"
                    href="process"
                    handleMenu={handleLink}
                  />
                </div>
                <div className="link-wrapper">
                  <AnimatedLink
                    text="Contact Us"
                    href="about#contact_us"
                    handleMenu={handleLink}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
